var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListOrder',{attrs:{"platform-order-source":"shopee"}})
}
var staticRenderFns = []

export { render, staticRenderFns }